import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Typography } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/GetApp';
import XLSX from 'xlsx';
import { orgName } from './OrganizationPicker';
import { useStyles } from './ImportExcelStyle';

const formatNumber = value =>
  typeof value === 'number' ? value.toLocaleString('ru-RU') : '—';

/**
 * Итог импорта: счётчики и таблица ошибок по строкам.
 * result — { total, imported, failed, errors: [{ row, field, message }] }
 */
export default function ImportResult({ organization, result }) {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const { total, imported, failed, errors } = result;

  const downloadReport = e => {
    e.preventDefault();
    const sheet = XLSX.utils.aoa_to_sheet([
      [t('importExcel_columnRow'), t('importExcel_columnField'), t('importExcel_columnError')],
      ...errors.map(error => [error.row, error.field, error.message])
    ]);
    sheet['!cols'] = [{ wch: 10 }, { wch: 30 }, { wch: 60 }];
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, t('importExcel_errors'));
    XLSX.writeFile(book, `${t('importExcel_reportName')}.xlsx`);
  };

  return (
    <>
      <Typography variant="body2">
        {t('importExcel_organization')}: <b>{orgName(organization, i18n.language)}</b> ·{' '}
        {t('importExcel_bin')} {organization.bin || '—'}
      </Typography>
      <div className={classes.stats}>
        <div className={classes.stat}>
          <Typography variant="body2" color="textSecondary">
            {t('importExcel_totalRows')}
          </Typography>
          <div className={classes.statValue}>{formatNumber(total)}</div>
        </div>
        <div className={`${classes.stat} ${classes.statSuccess}`}>
          <Typography variant="body2" color="inherit">
            {t('importExcel_imported')}
          </Typography>
          <div className={classes.statValue}>{formatNumber(imported)}</div>
        </div>
        <div className={`${classes.stat} ${classes.statFailed}`}>
          <Typography variant="body2" color="inherit">
            {t('importExcel_failed')}
          </Typography>
          <div className={classes.statValue}>{formatNumber(failed)}</div>
        </div>
      </div>
      {errors.length > 0 && (
        <>
          <div className={classes.errorsHeader}>
            <Typography className={`${classes.grow} ${classes.medium}`}>
              {t('importExcel_errors')}
            </Typography>
            <Link href="#" underline="always" className={classes.link} onClick={downloadReport}>
              <DownloadIcon fontSize="small" />
              {t('importExcel_downloadReport')}
            </Link>
          </div>
          <div className={classes.resultTableWrap}>
            <table className={classes.resultTable}>
              <thead>
                <tr>
                  <th className={classes.resultColRow}>{t('importExcel_columnRow')}</th>
                  <th className={classes.resultColField}>{t('importExcel_columnField')}</th>
                  <th>{t('importExcel_columnError')}</th>
                </tr>
              </thead>
              <tbody>
                {errors.map((error, index) => (
                  <tr key={index}>
                    <td>{error.row}</td>
                    <td>{error.field}</td>
                    <td className={classes.errorText}>{error.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}
